"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetNewPasswordWithToken = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useSetNewPasswordWithToken = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        keysUpdate: [
            keys_1.USER,
            keys_1.BALANCE,
            keys_1.WITHDRAWAL_BALANCE,
            keys_1.USER_KYC,
            keys_1.MY_LEVEL_PROGRESS,
            keys_1.TOURNAMENTS,
            keys_1.TOURNAMENTS_CURRENT,
            keys_1.DEPOSIT_METHODS,
        ],
        path: keys_1.SET_NEW_PASSWORD_WITH_TOKEN,
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        setNewPasswordWithToken: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useSetNewPasswordWithToken = useSetNewPasswordWithToken;
